import { render } from "./Modal.vue?vue&type=template&id=794eddf1&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=794eddf1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-794eddf1"

export default script